(function () {
  'use strict';
  if (window.ydsEnquiryConversionInstalled) return;
  window.ydsEnquiryConversionInstalled = true;

  const pixelId = 'BMMkghuVpfY9xupd4ak7uq';
  const pendingKey = 'yds.enquiry.pending.v1';
  const sentKey = 'yds.enquiry.sent.v1';
  const maxAge = 2 * 60 * 60 * 1000;
  let pixelReady = false;

  function read(key) {
    try { return JSON.parse(window.sessionStorage.getItem(key)); }
    catch (_) { return null; }
  }

  function write(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (_) { return false; }
  }

  function remove(key) {
    try { window.sessionStorage.removeItem(key); } catch (_) {}
  }

  function processingAllowed() {
    try {
      const privacy = window.Shopify.customerPrivacy;
      return privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }

  function pending() {
    const item = read(pendingKey);
    if (!item || item.form !== 'yds-project-enquiry' ||
        typeof item.id !== 'string' || !/^yds-(lead|test)-[0-9a-f-]{36}$/.test(item.id) ||
        !Number.isFinite(item.createdAt) || Date.now() - item.createdAt > maxAge ||
        item.createdAt > Date.now()) {
      remove(pendingKey);
      return null;
    }
    return item;
  }

  function hiddenField(form, name, value) {
    let field = form.elements.namedItem(name);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    field.value = value;
  }

  function prepareSubmission(form) {
    if (!processingAllowed() || !window.crypto || !window.crypto.randomUUID) {
      remove(pendingKey);
      return;
    }
    const body = form.elements.namedItem('contact[body]');
    const test = Boolean(body && /^\s*TEST ONLY\b/i.test(body.value));
    const candidate = pending();
    const previous = candidate && candidate.id.startsWith(test ? 'yds-test-' : 'yds-lead-') ? candidate : null;
    const item = previous || {
      form: 'yds-project-enquiry',
      id: 'yds-' + (test ? 'test-' : 'lead-') + window.crypto.randomUUID(),
      createdAt: Date.now()
    };
    if (!write(pendingKey, item)) return;
    hiddenField(form, 'contact[YDS enquiry reference]', item.id);
    const query = new URLSearchParams(window.location.search);
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']) {
      const value = query.get(key);
      if (value && /^[A-Za-z0-9_-]{1,128}$/.test(value)) {
        hiddenField(form, 'contact[' + key + ']', value);
      }
    }
  }

  function startPixel() {
    if (pixelReady) return;
    if (!window.oaiq) {
      const queue = function () { queue.q.push(arguments); };
      queue.q = [];
      window.oaiq = queue;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
      document.head.appendChild(script);
    }
    window.oaiq('consent', true);
    window.oaiq('init', { pixelId: pixelId });
    pixelReady = true;
  }

  function completeSubmission() {
    if (window.location.pathname !== '/pages/contactus' ||
        !document.querySelector('[data-yds-enquiry-accepted]')) return;
    const item = pending();
    if (!item) return;
    const sent = read(sentKey);
    if (Array.isArray(sent) && sent.includes(item.id)) {
      remove(pendingKey);
      return;
    }
    const ids = Array.isArray(sent) ? sent.slice(-49) : [];
    ids.push(item.id);
    if (!write(sentKey, ids)) return;
    remove(pendingKey);
    window.oaiq('measureSingle', pixelId, 'lead_created',
      { type: 'customer_action' }, { event_id: item.id, opt_out: true });
  }

  function refreshConsent() {
    if (!processingAllowed()) {
      remove(pendingKey);
      if (pixelReady) window.oaiq('consent', false);
      return;
    }
    startPixel();
    window.oaiq('consent', true);
    completeSubmission();
  }

  function init() {
    for (const form of document.forms) {
      const type = form.elements.namedItem('form_type');
      if (!type || type.value !== 'contact') continue;
      form.addEventListener('submit', function () {
        if (form.id === 'yds-project-enquiry') prepareSubmission(form);
        else remove(pendingKey);
      });
    }
    document.addEventListener('visitorConsentCollected', refreshConsent);
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) { if (!error) refreshConsent(); });
    } else {
      refreshConsent();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
